<template>
  <popupCharge
    :activation="charge"
    v-if="charge"
  />
  <div class="h-auto bg-white w-full pt-6 pb-8 pl-8 pr-8">
    <div class="">
      <div class="all">
        <div class="w-full flex text-c16 font-c7 text-left mb-6 text-titre">
          <div class="w-1/3">
            Nom
          </div>
          <div class="w-1/4 ml-4">
            Date de la demande
          </div>
          <div class="w-1/4 flex justify-start">
            Statut NIM
          </div>
          <div class="w-1/5 ml-4">
            Traitement DGI
          </div>
          <div class="w-1/5 ml-4">
            Numéro de Tel
          </div>
          <div class="w-1/5 ml-4">
            Statut
          </div>
        </div>
        <div class="diviser" />
        <div
          v-if="charge"
          class="flex justify-center mt-16"
        >
          <easy-spinner
            type="dots"
            size="70"
          />
        </div>
        <div
          class="text-center mt-10"
          v-if="tracker.length === 0 && !charge"
        >
          Aucun commerce pour le moment
        </div>
        <div
          v-for="(item, index) in tracker"
          :key="index"
          class="mt-5"
        >
          <div
            v-if="index > 0"
            class="diviser mt-5"
          />
          <div>
            <liste
              class="mt-5"
              :item="item"
              @show-details-popup="showDetailsPopup"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex mt-10 justify-end pb-10 pr-10">
      <div class="w-1/3 flex items-center justify-end">
        <div class="text-c16 font-c6">
          Page {{ page }} sur {{ totalPage }}
        </div>
        <icon
          :data="icons.prev"
          height="50"
          width="50"
          class="icone cursor-pointer ml-4"
          original
          @click="prev"
        />
        <icon
          :data="icons.next"
          height="50"
          width="50"
          class="icone cursor-pointer ml-4"
          original
          @click="next"
        />
      </div>
    </div>
  </div>

  <details-popup
    v-if="showPopup"
    :item="selectedItem"
    @close-popup="closeDetailsPopup"
  />
</template>

<script>
import arrow from '../../../assets/icons/arrow.svg'
import agenda from '../../../assets/icons/agenda.svg'
import down from '../../../assets/icons/down.svg'
import prev from '../../../assets/icons/prev.svg'
import next from '../../../assets/icons/next.svg'
import liste from './liste'
import detailsPopup from './detailsPopup'
import apiroutes from '../../../router/api-routes'
import http from '../../../plugins/https'
// import popupCharge from '../../popup/popupCharge'

export default {
  name: "Index",
  components: {
    liste,
    detailsPopup
    // popupCharge
  },

  props: {
    search: {
      type: String,
      default: null
    },
    filtrage: {
      type: String,
      default: null
    },
    startDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      icons: {
        arrow,
        agenda,
        down,
        prev,
        next
      },
      client: [],
      charge: true,
      page: 1,
      limite: 20,
      total: 0,
      totalPage: 0,
      devisPaginate: [],
      temoin: null,
      dataClient: [],
      allClient: [],
      // Variables pour le popup
      showPopup: false,
      selectedItem: null
    }
  },

  // Watchers pour les nouvelles props de date et recherche
  watch: {
    startDate: {
      handler() {
        this.resetPaginationAndLoad();
      },
      immediate: false
    },
    endDate: {
      handler() {
        this.resetPaginationAndLoad();
      },
      immediate: false
    },
    search: {
      handler() {
        this.resetPaginationAndLoad();
      },
      immediate: false
    },
    filtrage: {
      handler() {
        this.allDemandeParginate();
      },
      immediate: false
    }
  },

  computed: {
    tracker: function() {
      let retour = this.dataClient

      if (this.temoin !== this.filtrage) {
        this.allDemandeParginate()
      }
      this.$emit('stat', retour.length + ' / ' + this.total)
      return retour
    }
  },

  created() {
    this.allDemandeParginate() 
  },

  methods: {
    prev() {
      if (this.page > 1) {
        this.page = this.page - 1
        this.allDemandeParginate()
      }
    },

    next() {
      if (this.totalPage > this.page) {
        this.page = this.page + 1
        this.allDemandeParginate()
      }
    },

    activeCharge(value) {
      this.charge = value
    },

    // Réinitialise la pagination et recharge les données
    resetPaginationAndLoad() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.allDemandeParginate();
    },

    allDemandeParginate() {
      this.temoin = this.filtrage
      this.charge = true
      
      const body = {
        limit: this.limite,
        page: this.page,
        dgiStatus: this.filtrage === 'EN COURS' ? 'PENDING' : this.filtrage === 'APPROUVÉE' ? 'APPROVED' : 'REJECTED'
      }

      // Ajout des filtres de date si présents
      if (this.startDate) {
        body.startDate = this.startDate;
      }
      if (this.endDate) {
        body.endDate = this.endDate;
      }
      
      // Ajout du filtre de recherche si présent
      if (this.search) {
        body.search = this.search;
      }
      
      console.log('Paramètres de requête:', body);

      http.post(apiroutes.baseURL + apiroutes.allDemande, body)
        .then(response => {
          this.dataClient = response.rows
          this.total = response.count
          this.totalPage = Math.ceil(response.count / this.limite)
          if (this.totalPage === 0) {
            this.totalPage = 1
          }
          this.charge = false
          console.log(response)
        })
        .catch(error => {
          this.charge = false
          console.error('Erreur lors du chargement:', error)
          // Optionnel: afficher un message d'erreur à l'utilisateur
          if (this.$toast) {
            this.$toast.error('Une erreur est survenue lors du chargement des données');
          }
        })
    },

    // Méthodes pour gérer le popup - renommées pour plus de clarté
    showDetailsPopup(item) {
      this.selectedItem = item;
      this.showPopup = true;
    },

    closeDetailsPopup() {
      this.showPopup = false;
      this.selectedItem = null;
    }
  }
}
</script>

<style scoped>
.diviser {
  border-bottom: 1px solid #e5e7eb;
}

.text-titre {
  font-weight: 600;
}

.icone:hover {
  transform: scale(1.1);
  transition: transform 0.2s ease-in-out;
}

.opacity-50 {
  opacity: 0.5;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed:hover {
  transform: none;
}
</style>